import {
  PrimeVueChangeTheme, PrimeVueConfiguration,
} from '@NitrexGroup/primevue/config';
import {
  i18n,
} from '@i18n';
import {
  reactive,
} from 'vue';

import {
  TSupportedLocale,
} from '@/types/i18n.ts';
import {
  isNullish,
} from '@/utils/common.ts';
import {
  EMPTY_OBJECT,
} from '@/utils/common.ts';

type TPrimeVue = {
  config: PrimeVueConfiguration,
  changeTheme: PrimeVueChangeTheme,
};

export const primeVueStore = reactive({
  store: EMPTY_OBJECT as TPrimeVue,
  setStore(primeVue: TPrimeVue) {
    this.store = primeVue;
  },
  setLocale(locale: TSupportedLocale) {
    const translations = i18n.global.messages.value[locale]?.primeVue;
    if (isNullish(translations) || isNullish(this.store.config)) {
      return;
    }
    primeVueStore.store.config.locale = translations;
  },
});

export function setPrimeVueStore(primeVue: TPrimeVue): void {
  if (isNullish(primeVue) || isNullish(i18n.global)) {
    return;
  }

  primeVueStore.setStore(primeVue);
  primeVueStore.setLocale(i18n.global.locale.value);
}
